export const COPY = {
	changeLink: {
		key: "change-link",
		fallback: "Change",
	},
	selectCampusLink: {
		key: "select-campus-link",
		fallback: "Select campus for price",
	},
	header: {
		key: "campus-modal-header",
		fallback: "Choose your campus",
	},
	searchPlaceholder: {
		key: "campus-modal-search-placeholder",
		fallback: "Search city, state, or zip",
	},
	searchButton: {
		key: "campus-modal-search-button",
		fallback: "Search",
	},
	useLocation: {
		key: "campus-modal-use-location",
		fallback: "Use my current location",
	},
	viewOnMap: {
		key: "campus-modal-view-on-map",
		fallback: "View on Map",
	},
	campusDetails: {
		key: "campus-modal-campus-details",
		fallback: "Campus Details",
	},
	showAll: {
		key: "campus-modal-show-all",
		fallback: "Show all campuses",
	},
	confirm: {
		key: "campus-modal-confirm",
		fallback: "Confirm Campus",
	},
	noResults: {
		key: "campus-modal-no-results",
		fallback: "No campuses match your search.",
	},
	noResultsTitle: {
		key: "campus-modal-no-results-title",
		fallback: "There are no In-person locations near \u201C{{query}}\u201D",
	},
	noResultsBody: {
		key: "campus-modal-no-results-body",
		fallback:
			"We don't have a campus in that area yet, but you can take the same course online through our online formats",
	},
	exploreOnline: {
		key: "campus-modal-explore-online",
		fallback: "Explore online formats",
	},
	locationSearchQuery: {
		key: "campus-modal-location-search-query",
		fallback: "your location",
	},
	locationUnavailable: {
		key: "campus-modal-location-unavailable",
		fallback:
			"We couldn't determine your location. Try searching by city, state, or zip.",
	},
	resultsWithin: {
		key: "campus-modal-results-within",
		fallback: "Results within {{miles}} miles: {{countLabel}}",
	},
	locationsFoundOne: {
		key: "campus-modal-locations-found-one",
		fallback: "{{count}} location found",
	},
	locationsFoundMany: {
		key: "campus-modal-locations-found-many",
		fallback: "{{count}} locations found",
	},
	unknownRegion: {
		key: "campus-modal-unknown-region",
		fallback: "Unknown Region",
	},
	distanceMiles: {
		key: "campus-modal-distance-miles",
		fallback: "{{miles}} miles",
	},
} as const;
